"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventView = void 0;
var EventView;
(function (EventView) {
    EventView["EVENT"] = "EVENT";
    EventView["EVENT_WITH_STATS"] = "EVENT_WITH_STATS";
})(EventView = exports.EventView || (exports.EventView = {}));
//# sourceMappingURL=eventView.js.map